import {
  INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR,
  SYSTEM_INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR,
  hasConflictingInvoiceApproverAssignmentPermissions,
  hasConflictingSystemInvoiceApproverAssignmentPermissions,
} from './permission_utils.function';

export const INVOICE_APPROVER_CONFLICT_MESSAGE =
  'A user or permission group cannot include both "Manage Invoice Approver Assignments" and "Approve Invoice Approver Assignments".';

export const SYSTEM_INVOICE_APPROVER_CONFLICT_MESSAGE =
  'A user or permission group cannot include both "Manage System Invoice Approver Assignments" and "Approve System Invoice Approver Assignments".';

export const getActivePermissionNamesFromToggleState = (permissionList, toggleState) =>
  (permissionList || []).filter((p) => toggleState[p.name]).map((p) => p.name);

export const wouldConflictIfToggled = (
  permissionList,
  toggleState,
  permissionName,
  nextChecked
) => {
  const nextState = { ...toggleState, [permissionName]: nextChecked };
  const names = getActivePermissionNamesFromToggleState(permissionList, nextState);
  if (hasConflictingInvoiceApproverAssignmentPermissions(names)) {
    return true;
  }
  return hasConflictingSystemInvoiceApproverAssignmentPermissions(names);
};

export const getSelectedGroupPermissionNames = (groups, toggleState) => {
  const names = new Set();
  (groups || [])
    .filter((g) => toggleState[g.name])
    .forEach((g) => {
      (g.permissions || []).forEach((p) => {
        const n = typeof p === 'string' ? p : p?.name;
        if (n !== undefined && n !== null && n !== '') {
          names.add(n);
        }
      });
    });
  return [...names];
};

export const isInvoiceApproverConflictPermission = (name) =>
  INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR.includes(name) ||
  SYSTEM_INVOICE_APPROVER_ASSIGNMENT_CONFLICT_PAIR.includes(name);

export const getInvoiceApproverConflictMessage = (permissionNames) => {
  if (hasConflictingSystemInvoiceApproverAssignmentPermissions(permissionNames)) {
    return SYSTEM_INVOICE_APPROVER_CONFLICT_MESSAGE;
  }
  return INVOICE_APPROVER_CONFLICT_MESSAGE;
};
